<script setup lang="ts">
defineProps<{
    metrics: { title: string; metric: string | number | undefined }[];
}>();
</script>

<template>
    <div class="grid grid-cols-2 gap-4 md:grid-cols-3 xl:grid-cols-5">
        <UiPanel v-for="{ title, metric } in metrics" :key="title">
            <dt class="text-center text-xs font-medium text-gray-500">{{ title }}</dt>
            <dd class="mt-1 text-center text-2xl font-semibold text-gray-800">{{ metric }}</dd>
        </UiPanel>
    </div>
</template>
